import React, { CSSProperties } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBadgeCheck } from '@fortawesome/pro-solid-svg-icons'
import { Tooltip } from '~/components/Tooltip'
import { Series } from '~/domain/Series'
import styles from './index.module.scss'

interface SeriesHeaderProps {
  series: Series
}

export const SeriesHeader: React.FC<SeriesHeaderProps> = ({ series }) => {
  return (
    <div className={ styles['series-header__container'] }>
      <div
        data-testid="series-header"
        style={ {
          '--headerUrl': `url(${ series.headerImageUrl })`,
          '--headerUrlMobile': `url(${ series.headerImageUrlMobile })`,
        } as CSSProperties }
        className={ styles['series-header__header'] }
      >
        <img
          src={ series.organizer.avatarUrl }
          alt={ `Avatar of ${series.organizer.acronym}` }
          className={ styles['series-header__image'] }
        />
      </div>

      <h2 className={ styles['series-header__organizer-name'] }>
        { series.organizer.name }

        <FontAwesomeIcon
          className={ styles['series-header__organizer-verification-mark'] }
          icon={ faBadgeCheck }
          data-tooltip-id="official"
          data-tooltip-content={ `All NFTs are official awards by the ${series.organizer.name}` }
        />

        <Tooltip id="official" />
      </h2>
      <h1 className={ styles['series-header__series-name'] }>
        { series.name }
      </h1>
      <p className={ styles['series-header__series-description'] }>
        { series.description }
      </p>
    </div>
  )
}
